import {
  animate,
  AnimationTriggerMetadata,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

/**
 * Animations used by the product card.
 */
export const siteSelectorAnimation: AnimationTriggerMetadata = trigger(
  'slideFromLeft',
  [
    state('open', style({ transform: 'translateX(0)', opacity: 1 })),
    state('closed', style({ transform: 'translateX(-120%)', opacity: 0 })),
    transition('open => closed', [animate('200ms')]),
    transition('closed => open', [animate('200ms')]),
  ],
);
